module.exports = __webpack_public_path__ + "static/img/fuel-gas.c6a4102c.svg";